module.exports = __webpack_public_path__ + "img/techno-cloud-logo-white.795bf075.png";